import * as React from 'react'
import { useQuery } from 'react-query'
import { IOption, IProviderProps } from '@user/components/Filters'
import { ServiceConfig } from '@user/store/services/config'
import { get } from '@user/store/services/crud'

export const ServiceProvider: React.FC<IProviderProps> = ({ render }) => {
  const { data, isFetching } = useQuery(
    ['filters', 'lead', 'service'],
    async (): Promise<IOption[]> => {
      const result = await get(
        `${ServiceConfig.baseAPIUrl}${ServiceConfig.filters(
          'leads',
          'Services',
        )}`,
      )

      const services: { id: string; name: string }[] = await result.json()
      const options: IOption[] = services.map(({ id, name }) => ({
        label: name,
        value: id,
      }))
      return options
    },
  )

  return <>{render(data ?? [], isFetching)}</>
}
ServiceProvider.displayName = 'ServiceProvider'
